// NOTE: on assume qu'un Promise polyfill est déjà loadé dans IE

import { PageHooks } from "barba"
import { ValidationService } from "aspnet-validation"

class BarbaValidationService extends ValidationService {
    constructor() {
        super()

        this.addMvcProviders()

        const beforeEnter = this.beforeEnter.bind(this)
        const afterLeave = this.afterLeave.bind(this)

        new class extends PageHooks {
            beforeEnter(data) {
                beforeEnter(data)
            }
            afterLeave(data) {
                afterLeave(data)
            }
        }
    }
    afterLeave({ current }) {
        [...this.elementUIDs].forEach(({ node, uid }) => {
            if (current.container.contains(node)) {
                this.removeUID(uid)
            }
        })
    }
    beforeEnter() {
        this.scanMessages()
        this.scanInputs()
    }
    removeUID(uid) {
        const node = this.elementByUID[uid]

        // Remove listener
        switch (node.nodeName) {
            case 'FORM':
                node.removeEventListener("submit", this.elementEvents[uid])
                // Note : It's impossible to remove form "reset" listener
                // because of anonymous function.
                break
            case 'SELECT':
                node.removeEventListener("change", this.elementEvents[uid])
                break
            default:
                node.removeEventListener("input", this.elementEvents[uid])
        }

        // Remove messages
        if(node.nodeName !== "FORM") {
            delete this.messageFor[node.name]
        }

        // Remove from elementUIDs array
        const uidIndex = this.elementUIDs.map(o => o.uid).indexOf(uid)
        this.elementUIDs.splice(uidIndex, 1);

        // Delete properties
        delete this.elementByUID[uid]
        delete this.elementEvents[uid]
        delete this.formInputs[uid]
        delete this.summary[uid]
        delete this.validators[uid]

        // Update summary render
        this.renderSummary()
    }
}

new BarbaValidationService()
